import { render, staticRenderFns } from "./GenericUserInfo.vue?vue&type=template&id=6b519b0e&scoped=true&"
import script from "./GenericUserInfo.vue?vue&type=script&lang=js&"
export * from "./GenericUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./GenericUserInfo.vue?vue&type=style&index=0&id=6b519b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b519b0e",
  null
  
)

component.options.__file = "GenericUserInfo.vue"
export default component.exports